import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import "./styles.css";

// import required modules
import { Autoplay, EffectFade } from "swiper";
import './HomeBanner.css'
import { Link } from "react-router-dom";

const HeroHomeContent = () => {
    return (
        <div>
            <section class="text-gray-800 background-radial-gradient w-full ">
                <div class="px-6 md:px-12 text-center lg:text-left">
                    <div class="max-w-6xl h-full mx-auto py-10 md:py-20">
                        <div class="grid lg:grid-cols-2 gap-12 flex items-center">
                            <div class="mt-12 lg:mt-0">
                                <h1 class="text-3xl md:text-4xl xl:text-5xl font-bold tracking-tight mb-12 text-bg" >
                                    Are you ready <br /><span className='text-span text-5xl md:text-6xl xl:text-7xl'>for an adventure?</span>
                                </h1>
                                <p class="text-lg text-para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima officia consequatur
                                    adipisci tenetur repudiandae rerum quos.
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima officia consequatur
                                    adipisci tenetur repudiandae rerum quos.
                                </p>
                                <div className='flex items-center gap-3 md:gap-7 flex-col md:flex-row'>
                                    <Link to='/contact' class="block h-10 md:h-12 flex items-center justify-center px-5 py-2 mt-7 md:mt-4 text-lg text-center capitalize transition-colors duration-300 transform border rounded-md dark:hover:bg-gray-700 dark:text-white lg:mt-7 hover:bg-gray-100 lg:w-44 background-radial-gradient text-white font-semibold outline-none border-none" >
                                        <i class="fa-solid fa-book-open-reader pr-3"></i>  Contact Us
                                    </Link>
                                    <Link to='/allcourse' class="block h-10 md:h-12 flex items-center justify-center px-5 py-2 md:mt-4 text-lg text-center capitalize transition-colors duration-300 transform border rounded-md dark:hover:bg-gray-700 dark:text-white lg:mt-7 hover:bg-transparent lg:w-auto background-radial-gradient text-white font-semibold outline-none border-none" >
                                        <i class="fa-solid fa-book-open-reader pr-3"></i>Browse Course
                                    </Link>

                                </div>
                            </div>
                            <div class="mb-12 lg:mb-0 ">
                            <img class="w-full h-full lg:max-w-3xl rounded-3xl" src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y29tcHV0ZXIlMjB0cmFpbmluZ3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" alt="Catalogue-pana.svg" />
                                {/* <Swiper
                                    slidesPerView={1}
                                    spaceBetween={30}
                                    autoplay={{
                                        delay: 3500,
                                        disableOnInteraction: false,
                                    }}
                                    loop={true}
                                    effect={"fade"}
                                    // navigation={true}
                                    // pagination={{
                                    //     clickable: true,
                                    // }}
                                    modules={[Autoplay,
                                        EffectFade]}
                                    className="mySwiper"
                                >
                                    <SwiperSlide>
                                        <img class="w-full h-full lg:max-w-3xl rounded-3xl" src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y29tcHV0ZXIlMjB0cmFpbmluZ3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" alt="Catalogue-pana.svg" />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img class="w-full h-full lg:max-w-3xl rounded-3xl" src="https://media.istockphoto.com/id/1399784221/photo/filling-form-online-questionnaire-survey.jpg?b=1&s=170667a&w=0&k=20&c=jBT7dKc_yfv-a3LLnV-iJRn8V5mT21kj8uUSUENJGVY=" alt="Catalogue-pana.svg" />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img class="w-full h-full lg:max-w-3xl rounded-3xl" src="https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8Y29tcHV0ZXIlMjB0cmFuaW5nfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60" alt="Catalogue-pana.svg" />
                                    </SwiperSlide>
                                </Swiper> */}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <header class="bg-white dark:bg-gray-900"> */}
            {/* <div class="max-w-6xl px-5 xl:px-0 py-16 mx-auto">
                    <div class="items-center lg:flex">
                        <div class="w-full lg:w-1/2">
                            <div class="lg:max-w-lg">
                                <h1 class="text-3xl font-semibold text-gray-800 dark:text-white lg:text-4xl">Best place to choose <br /> your <span class="text-blue-500 ">clothes</span></h1>

                                <p class="mt-3 text-gray-600 dark:text-gray-400">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Porro beatae error laborum ab amet sunt recusandae? Reiciendis natus perspiciatis optio.</p>

                                <button class="w-full px-5 py-2 mt-6 text-sm tracking-wider text-white uppercase transition-colors duration-300 transform bg-blue-600 rounded-lg lg:w-auto hover:bg-blue-500 focus:outline-none focus:bg-blue-500">Shop Now</button>
                            </div>
                        </div>

                        <div class="flex items-center justify-center w-full mt-6 lg:mt-0 lg:w-1/2">
                            <img class="w-full h-full lg:max-w-3xl rounded-3xl" src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y29tcHV0ZXIlMjB0cmFpbmluZ3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" alt="Catalogue-pana.svg" />
                        </div>
                    </div>
                </div> */}
            {/* </header> */}
            {/* <section class="bg-white dark:bg-gray-900">

                <div class="container px-6 py-16 mx-auto text-center">
                    <div class="max-w-lg mx-auto">
                        <h1 class="text-3xl font-semibold text-gray-800 dark:text-white lg:text-4xl">Building Your Next App with our Awesome components</h1>
                        <p class="mt-6 text-gray-500 dark:text-gray-300">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Libero similique
                            obcaecati illum mollitia.</p>
                        <button class="px-5 py-2 mt-6 text-sm font-medium leading-5 text-center text-white capitalize bg-blue-600 rounded-lg hover:bg-blue-500 lg:mx-0 lg:w-auto focus:outline-none">
                            Start 14-Day free trial
                        </button>
                        <p class="mt-3 text-sm text-gray-400 ">No credit card required</p>
                    </div>

                    <div class="flex justify-center mt-10">
                        <img class="object-cover w-full h-96 rounded-xl lg:w-4/5" src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80" />
                    </div>
                </div>
            </section> */}
        </div>
    );
};

export default HeroHomeContent;